import checkbox from './checkbox.svg';
import checked from './checked.svg';
import square from './square.svg';

export default {
  checkbox,
  checked,
  square,
};
